export default "__VITE_ASSET__Bjjgv2pm__"